import { get } from 'lodash-es';
import React, { useEffect, useState } from 'react';
import { Container, Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import PhotoGallery from '../../../shared/components/PhotoGallery/PhotoGallery';
import SafeRoute from '../../../shared/components/SafeRoute';
import CampaignProfile from './CampaignProfile/CampaignProfile';
import General from './General/General';
import LoyaltyProgram from './LoyaltyProgram/LoyaltyProgram';
import './Profile.scss';
import SocialPlatforms from './SocialPlatforms/SocialPlatforms';
import Payments from './Payments';

const PATH = '/profile';

const Profile = () => {
  const { t } = useTranslation();
  const match = useRouteMatch();
  const userData = useSelector(store => get(store, 'auth.user'));
  const simulatedData = useSelector(store => get(store, 'config.simulatedData'));
  const loadingUser = useSelector(store => get(store, 'auth.loading'));

  const [state, setState] = useState({
    path: match.url,
    user: {}
  });

  useEffect(() => {
    if (!loadingUser) {
      setState({ ...state, user: simulatedData || userData });
    }
  }, [loadingUser]);

  const { user } = state;
  const isEuropeanUser = user.european;
  const isAmerican = user.country === 'United States';
  const id = user.id;

  return (
    <div className="home-page" id="profile-page">
      <Nav
        className="navbar-secondary position-relative"
        bg="light"
        variant="tabs"
        defaultActiveKey={state.path}>
        <Nav.Link as={Link} eventKey={PATH} to={PATH}>
          {t('influencers.common.general')}
        </Nav.Link>
        {!loadingUser && !isEuropeanUser && <Nav.Link as={Link} eventKey={`${PATH}/campaign`} to={`${PATH}/campaign`}>
          {t('influencers.pages.profile.general.label_tab')}
        </Nav.Link>}
        <Nav.Link as={Link} eventKey={`${PATH}/social-platforms`} to={`${PATH}/social-platforms`}>
          {t('influencers.pages.profile.social_platforms.title')}
        </Nav.Link>
        {user.admin && !user.restricted_admin && !isAmerican &&
          <Nav.Link as={Link} eventKey={`${PATH}/payments`} to={`${PATH}/payments`}>
            Payments
          </Nav.Link>
        }
        {/* <Nav.Link as={Link} eventKey={`${PATH}/loyalty-program`} to={`${PATH}/loyalty-program`}>
          {t('influencers.pages.profile.loyalty_program.title')}
        </Nav.Link> */}
      </Nav>

      <Container >
        <PhotoGallery xs={4} sm={3} lg={4} userId={id} platform={'instagram'} headerMode />
      </Container>

      <Switch>
        <SafeRoute path={`${PATH}/campaign`} component={CampaignProfile} />

        <Route path={`${PATH}/social-platforms`} component={SocialPlatforms} />
        <Route path={`${PATH}/payments`} component={Payments} />
        {/* <Route path={`${PATH}/loyalty-program`}>
          <LoyaltyProgram />
        </Route> */}

        <Route exact path={PATH}>
          <General />
        </Route>

        <Route path="*">
          <Redirect to='/404' />
        </Route>

      </Switch>
    </div>
  );
};

export default React.memo(Profile);
